/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:20:23
 * @Description: response body
 */
import config from "@/config";

export function genResBody(data, code = config.SERVICES.RESPONSE_CODE.OK, message = "OK") {
	return {
		[config.SERVICES.RESPONSE_CODE_FILED]: code,
		[config.SERVICES.RESPONSE_MESSAGE_FILED]: message,
		[config.SERVICES.RESPONSE_DATA_FILED]: data,
	};
}
